<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2026-06-22 15:20:00
 * @LastEditors: hl
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/detail/logistics/components/SwitchBar/index.vue
-->
<template>
  <div class="sku_con">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="sku_list"
      :class="{ sku_list_bg: value === index }"
      @click="switchSku(index)"
    >
      <div class="item_width">
        <div class="font12 font_weight400 colo055 list_item">
          <span :class="{ item_color: value === index }" class="item_item">
            {{ item.parcelName || "包裹" + (index + 1) }}
          </span>
        </div>
      </div>
      <div class="right_line"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    value: {
      type: Number,
      default: 0
    }
  },
  methods: {
    switchSku(index) {
      this.$emit("input", index);
    }
  }
};
</script>

<style lang="less" scoped>
.sku_con {
  display: flex;
  overflow-y: hidden;
  flex-wrap: nowrap;
  background: #f6f7f8;
  .sku_list_bg {
    background: #fff;
    box-shadow: 0px 0px 6px 0px rgba(193, 200, 207, 0.8);
    border-radius: 0px 0px 6px 6px;
    border-left: none !important;
    padding: 9px 0 !important;
    margin: 0 !important;
  }
  .sku_list {
    margin: 9px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item_width {
      width: 100px;
      text-align: center;
    }
    .right_line {
      width: 1px;
      height: 8px;
      background: #000;
      border-radius: 1px;
      opacity: 0.1;
    }
    .item_item {
      line-height: 16px;
      display: inline-block;
    }
    .item_color {
      font-weight: 500;
      color: #bf9264;
    }
  }
}
</style>
